<template>
  <div>
    <div class="control">
        <div class="columns">
          <div class="column is-12">
            <b-tag
              style="bottom: 0.3em; margin-right: 0.2em"
              size="is-small"
              type="is-light"
              >Text
            </b-tag>
            {{ row.text }}

            <div class="control" style="margin-top: 1em; margin-bottom: 0.5em">

              <b-tag
                  style="bottom: 0.25em; margin-right: 1em"
                  size="is-small"
                  type="is-light"
                >
                  Project
              </b-tag>

              {{ this.project.id }}
            
            </div>

            <div class="control" style="margin-top: 1em; margin-bottom: 0.5em">
              <b-tag
                style="bottom: 0.25em; margin-right: 1em"
                size="is-small"
                type="is-light"
              >
                Model Version
              </b-tag>

              {{ this.project.modelId }}
            
            </div>

            <div class="control" style="margin-top: 1em; margin-bottom: 0.5em">
              <!-- prediction-->
              <b-taglist attached>
                <b-tag
                  style="bottom: 0.25em; margin-right: 1em"
                  size="is-small"
                  type="is-light"
                >
                  Prediction
                </b-tag>

                <b-tag
                  style="margin-right: 2px"
                  size="is-small"
                  type="is-light"
                  v-for="(prediction) in Array.isArray(row.responseBody.predictions)
                    ? row.responseBody.predictions.filter( sc => sc.score > 0)
                    : [row.responseBody.predictions]"
                >

                {{ prediction.label }} ({{ prediction.score.toFixed(2) }})

                </b-tag>
              </b-taglist>
            </div>
              
            <div class="control" style="margin-top: 1em; margin-bottom: 0.5em">
              <b-taglist attached>
              <b-tag
                style="bottom: 0.50em; margin-right: 0.5px"
                size="is-small"
                type="is-light"
                >
                  Log_recorded
                  
              </b-tag>

              <span :class="
                            [
                                'tag',
                                {'is-danger': !isRecorded(row) },
                                {'is-success': isRecorded(row) }
                            ]">
                                {{ row.is_recorded || false }}
              </span>
              </b-taglist>

              <p style="bottom: 0.50; margin-bottom: -1em; color: gray">
                <small
                  ><small>
                    <span>
                      Date: {{ new Date(parseInt(row.createdAt) * 1000).toLocaleDateString() }}
                    </span>


                  </small></small>
                <small><small> </small></small>
              </p>

            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>

export default {
//   props: {
//     train: Boolean,
//     row: Object,
//     project: Object
//   },
  props: ["row", "project", "Logs"],
  name: "Logs",
  data: function () {
    return {
    };
  },

  computed: {},
  filters: {},
  methods: {
    isRecorded(row) {
      return !!row.is_recorded;
    },
  },
  mounted() {},
  created() {},
};

</script>
<style lang="scss" scoped>
.vertical {
  height: 500px;
  /*Line height*/
  border-left: 2px solid;
  /* Add left border on the div like if it was a line.*/
}

.no-active:focus {
  outline: none;
}

.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}

.labelCode {
  position: absolute;
  /* Set the span's position to absolute */
  bottom: 0;
  /* Align the span to the bottom */
  left: 50%;
  /* Align the span horizontally */
  transform: translateX(-50%);
  /* Center the span horizontally */
  font-size: 9px;
  /* Set the font size of the span */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active to prior versions 2.1.8 */ {
  opacity: 0;
}
</style>
